module.exports = __webpack_public_path__ + "images/bg-email-top-60bd8ce41ce5e27b7574d58e43c32cd1.png";